// Copyright 2025, University of Maryland, All Rights Reserved
/** Shared score display utilities. */

/** Get Tailwind text color class based on score type. */
export function scoreTypeColor(scoreType: string | undefined): string {
  switch (scoreType) {
    case 'positive': return 'text-emerald-600'
    case 'negative': return 'text-red-600'
    case 'neutral': return 'text-amber-600'
    default: return 'text-muted-foreground'
  }
}
